module.exports = __webpack_public_path__ + "static/media/orders-trash.3cbec553.svg";